module.exports = function(query){

    if(document.querySelector(query) == null) {
        return false;
    } else {
        return true;
    }

};



// WEBPACK FOOTER //
// ./js-source/base/exists.js